import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import reducer, { initializeState } from './reducers';
import { routerMiddleware } from 'react-router-redux';

let store = null;
export const getStore = (history) => {
  if (store !== null) return store;

  const middleware = routerMiddleware(history);
  store = createStore(
    reducer,
    initializeState(),
    composeWithDevTools(applyMiddleware(thunkMiddleware, middleware)),
  );
  return store;
};

export default getStore;
